const privacyPolicy = [
    {
        id: "overview",
        title: "1. Overview",
        content: "Welcome to [Your Construction Company Name]. We are committed to delivering high-quality construction services while ensuring transparency and client satisfaction."
    },
    {
        id: "data-privacy",
        title: "2. Client Information",
        content: "We collect necessary details to manage projects efficiently, including:",
        list: [
            "Client name, contact details, and project location",
            "Project requirements and design preferences",
            "Payment and billing details",
            "Legal documents required for construction approvals"
        ]
    },
    {
        id: "terms-of-service",
        title: "3. Terms of Service",
        content: "By using our construction services, you agree to our terms, including project timelines, material usage, and adherence to building codes."
    },
    {
        id: "project-rights",
        title: "4. Project Rights",
        content: "Clients have the right to:",
        list: [
            "Receive regular project updates",
            "Request design modifications within contract terms",
            "Raise concerns about safety or quality standards"
        ]
    },
    {
        id: "safety-security",
        title: "5. Safety & Security",
        content: "We follow strict safety protocols on all construction sites, ensuring compliance with industry regulations and worker protection standards."
    },
    {
        id: "payments",
        title: "6. Payments",
        content: "Payments must be made as per the agreed contract schedule. Late payments may result in project delays or additional fees."
    },
    {
        id: "third-party",
        title: "7. Third-Party Contractors",
        content: "We may collaborate with third-party contractors for specialized services such as plumbing, electrical work, and landscaping. We ensure they meet our quality standards."
    },
    {
        id: "warranties",
        title: "8. Warranties & Guarantees",
        content: "We provide warranties on structural work and materials used in construction. Warranty details will be outlined in the project contract."
    },
    {
        id: "compliance",
        title: "9. Compliance & Regulations",
        content: "Our projects adhere to local and national construction laws, environmental regulations, and zoning policies."
    },
    {
        id: "policy-updates",
        title: "10. Policy Updates",
        content: "We may update this policy periodically to reflect changes in regulations or company operations."
    }
];

export default privacyPolicy;